export const MESSAGES = {
	UPDATE_PROFILE_SUC: 'Profile Updated Successfully',
};
